<template>
<div>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form>
            <el-form-item>
                <el-input placeholder="订单号" v-model="weiOrderIdParam" style="width:300px"></el-input>
                <el-date-picker type="date" v-model="startDate" placeholder="开始日期">
                </el-date-picker>
                <el-date-picker type="date" placeholder="结束日期" v-model="endDate">
                </el-date-picker>
                <el-button type="primary" @click="searchDate()">查询</el-button>
            </el-form-item>
        </el-form>
    </el-col>

    <el-table :data="rechargeList" border v-loading="listLoading" style="width: 100%;margin-top:5px;">
        <el-table-column sortable prop="weiorderid" label="订单号" min-width="200">
        </el-table-column>
        <el-table-column prop="ordertimestr" label="充值时间" min-width="180" sortable>
        </el-table-column>
        <el-table-column prop="total" label="续费卡数" min-width="150" sortable>
        </el-table-column>
        <el-table-column prop="money" label="支付金额" min-width="80" sortable>
        </el-table-column>
        <el-table-column label="支付方式" min-width="80" sortable>
            <template>微信支付</template>
        </el-table-column>
        <el-table-column prop="money" label="支付状态" min-width="80" sortable>
            <template>已支付</template>
        </el-table-column>
        <el-table-column prop="serviceusername" label="代理商名称" min-width="150" sortable>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="80">
            <template scope="scope">
                <el-button @click="handleClick(scope.$index, scope.row)" size="small">查看</el-button>
            </template>
        </el-table-column>
    </el-table>
    <el-col :span="24" class="toolbar" style="text-align:right">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
    </el-col>
    <!--充值弹框界面-->
    <el-dialog title="充值明细" :visible.sync="rechargeDialog" width="60%" :close-on-click-modal="false">
        <!--工具条-->
        <el-row>
            <el-col :span="24" class="toolbar" style="padding-bottom: 0px;margin-top:0px;">
                <el-form>
                    <el-form-item>
                        <el-input placeholder="输卡号/查询码/代理商名" v-model="detailInfo.info" style="width:200px"></el-input>
                        <el-button type="primary" @click="getDetailList()">查询</el-button>
                        <el-button type="primary" @click="exportTable()">导出EXCEL</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
            <el-col :span="24">
                <!--列表(查询结果-当前页)row-style="height:12px;"-->
                <el-table :data="rechageDetailList" highlight-current-row v-loading="detailInfo.listLoading" style="width: 100%;line-height:3px;" height="450" border>
                    <!-- 
                    <el-table-column sortable prop="weiorderid" label="微信订单号" min-width="280">
                    </el-table-column>
                    <el-table-column sortable prop="orderid" label="内部订单号" min-width="200">
                    </el-table-column> -->
                    <el-table-column prop="msisdn" label="卡号" min-width="150" sortable>
                    </el-table-column>
                    <!-- <el-table-column prop="packtype" label="套餐类别" min-width="120" sortable>
                    </el-table-column> -->
                    <el-table-column prop="packname" label="套餐名称" min-width="150" sortable>
                    </el-table-column>

                    <!--
                        <el-table-column prop="querycode" label="查询代码" min-width="150" sortable>
                        </el-table-column>
                        <el-table-column prop="iccid" label="ICCID" min-width="220" sortable>
                        </el-table-column>
                        -->

                    <el-table-column prop="rechargePrice" label="套餐费用" min-width="150" sortable>
                    </el-table-column>
                    <el-table-column prop="arreas" label="欠费补缴" min-width="150" sortable>
                    </el-table-column>
                    <el-table-column prop="money" label="实际支付(元)" min-width="150" sortable>
                    </el-table-column>
                    <el-table-column prop="expireTime" label="充值前到期时间" min-width="150" sortable>
                    </el-table-column>
                    <el-table-column prop="rechargeExpireTime" label="充值后到期时间" min-width="150" sortable>
                    </el-table-column>

                    <!-- <el-table-column prop="ordertimestr" label="充值时间" min-width="180" sortable>
                    </el-table-column>
                    <el-table-column prop="serviceusername" label="代理商名称" min-width="150" sortable>
                    </el-table-column>
                    <el-table-column prop="remark" label="充值备注" min-width="150" sortable>
                    </el-table-column> -->
                </el-table>
            </el-col>
        </el-row>
        <el-row style="line-height:32px;margin-top:15px;">
            <!--工具条(分页)-->
            <!-- <el-col :span="8">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="prev, pager, next" :total="total" style="padding-top:2px;">
                </el-pagination>
            </el-col> -->
            <el-col :span="24" class="toolbar" style="text-align:right">
                <el-pagination @size-change="dailogSizeChange" @current-change="dialogCurrentChange" :page-sizes="[10, 20, 50, 100]" :page-size="this.detailInfo.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="this.detailInfo.total">
                </el-pagination>
            </el-col>
        </el-row>
    </el-dialog>
</div>
</template>

<script>
import {
    getRechargeList,
    getRechargeDetail
} from '../../api/api'
import util from '../../common/js/util'

export default {

    data() {
        return {
            checkIfo: false,
            startDate: '',
            endDate: '',
            rechargeDialog: false, //弹窗的关闭状态
            currentPage: 1, //当前页
            total: 1, //数据条数
            pageSize: 10,
            listLoading: true,
            detailInfo: {
                currentPage: 1, //当前页
                total: 1, //数据条数
                pageSize: 10,
                listLoading: true,
                info: '' //卡号查询字段
            },
            weiorderid: '', //查看详情时的参数
            rechargeList: [], //充值列表
            rechageDetailList: [], //充值详细列表
            weiOrderIdParam: ''

        }
    },
    mounted() {
        this.getlist();
    },

    methods: {
        //查看详细充值记录信息
        handleClick(index, row) {
            //弹窗展示详细的充值记录
            //调用查询详细充值接口，查询数组
            //打开弹窗
            this.weiorderid = row.weiorderid;
            this.rechargeDialog = true;
            this.detailInfo.info = '';
            this.getDetailList();
        },
        search() {
            //过滤查询
            if (this.startDate > this.endDate) {
                this.$message({
                    message: '开始时间不能大于结束时间',
                    type: 'warning'
                });
                this.checkIfo = false;
                this.startDate = "";
                this.endDate = "";
            }
            if ((this.startDate !== "" && this.endDate !== "") || (this.startDate == "" && this.endDate == "")) {
                this.checkIfo = true;
            } else {
                this.$message({
                    message: '选择日期区间时不能有空值',
                    type: 'warning'
                });
                this.startDate = "";
                this.endDate = "";
                this.checkIfo = false;
            }
        },
        searchDate() {
            if ((this.startDate !== "" && this.endDate !== "") || (this.startDate == "" && this.endDate == "")) {
                //过滤查询
                if (this.startDate > this.endDate) {
                    this.$message({
                        message: '开始时间不能大于结束时间',
                        type: 'warning'
                    });
                    return;
                }
                this.getlist();
            } else {
                this.$message({
                    message: '选择日期区间时不能有空值',
                    type: 'warning'
                });
                return;
            }
        },
        //分页查询数据
        getlist() {

            this.startDate = (!this.startDate || this.startDate == '') ? '' : util.formatDate.format(new Date(this.startDate), 'yyyy-MM-dd');
            this.endDate = (!this.endDate || this.endDate == '') ? '' : util.formatDate.format(new Date(this.endDate), 'yyyy-MM-dd');

            let para = {
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                startDate: this.startDate,
                endDate: this.endDate,
                weiOrderId: this.weiOrderIdParam
            };
            this.listLoading = true;
            getRechargeList(para).then((res) => {
                this.rechargeList = res.data.list;
                this.total = res.data.total;
                this.listLoading = false;
            });
        },
        //分页查询数据
        getDetailList() {
            let para = {
                pageNum: this.detailInfo.currentPage,
                pageSize: this.detailInfo.pageSize,
                info: this.detailInfo.info,
                //传入指定参数的微信订单号进行筛选
                weiOrderId: this.weiorderid,
            };
            this.detailInfo.listLoading = true;
            getRechargeDetail(para).then((res) => {
                this.rechageDetailList = res.data.list;
                this.detailInfo.total = res.data.total;
                this.detailInfo.listLoading = false;
            });
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getlist();
        },
        handleCurrentChange(val) {
            //换页查询数据
            this.search();
            this.currentPage = val;
            this.getlist();
        },
        dailogSizeChange(val) {
            this.detailInfo.pageSize = val;
            this.getDetailList();
        },
        dialogCurrentChange(val) {
            //换页查询数据
            // this.search();
            this.detailInfo.currentPage = val;
            this.getDetailList();
        },
        exportTable() {
            let para = "";
            para += "info=" + ((!this.detailInfo.info || this.detailInfo.info == '') ? '' : this.info);
            para += "&weiOrderId=" + this.weiorderid;
            location.href = "/api/recharge/exportDetailXls?" + para;
        }
    }
}
</script>
<

<style>
.border-table {
    border-collapse: collapse;
    border: none;
    width: 100%;
}

.border-table td {
    border: solid #dfe8ec 1px;
    background: #fff;
    font-size: 14px;
    padding: 12px 1px 12px 12px;
    color: #009966;
    line-height: 28px;
}

td.alt {
    background: #EFF2F7;
    color: #8492A6;
}

.alt {
    width: 100px;
}
</style>



// WEBPACK FOOTER //
// query_recharge.vue?004ba092